<template>
    <div style="height: 100%">
        <v-card style="height: 100%">
            <v-card-text class="pa-8">
                <v-tabs slider-color="accent" v-model="tabs">
                    <v-tab href="#users">
                        Users
                    </v-tab>
                    <!-- <v-tab href="#alarms">
                        Alarmas
                    </v-tab>
                    <v-tab href="#rates">
                        Tarifas
                    </v-tab> -->
                </v-tabs>

                <v-tabs-items v-model="tabs">
                    <v-tab-item :value="'users'">
                        <users/>
                    </v-tab-item>
                    <!-- <v-tab-item :value="'alarms'">
                        <alarms/>
                    </v-tab-item>
                    <v-tab-item :value="'rates'">
                        <rates />
                    </v-tab-item> -->
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
// import rates from '../components/configuration/rates'
import users from '../components/settings/users'
// import alarms from '../components/configuration/alarms'
export default {
    name: 'Settings',
    components: { users },
    data() {
        return {
            tabs: null
        }
    },
}
</script>